// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FPhzz","footer__copyright":"Footer_footer__copyright__qJm-i"};